import React from 'react';
import { makeStyles } from '@mui/styles';
import { AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import { CodeHighlighter } from '../index';
import { AdminProgressBar } from '../../../../components';

const useStyles = makeStyles((theme) => ({
  pre: {
    whiteSpace: 'pre-wrap',
  },
  childAccordion: {
    display: 'block',
  },
  headingPost: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: theme.palette.success.main,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const Challenges = () => {
  const classes = useStyles();
  return (
    <AccordionDetails className={classes.childAccordion}>
      <Typography>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          justifyContent={'space-between'}
        >
          <Grid
            item
            xs={2}
          >
            <h3>Example Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
    "data": [
        {
            "id": 73,
            "name": "Add Dairy"
        },
        {
            "id": 52,
            "name": "Add Fish"
        },
        {
            "id": 75,
            "name": "Add Lean Poultry"
        },
        {
            "id": 47,
            "name": "Avoid Fast Food"
        },
        {
            "id": 41,
            "name": "Avoid Soda"
        },
        {
            "id": 58,
            "name": "Avoid Sugar at Breakfast"
        },
        {
            "id": 43,
            "name": "Avoid Sweetened Beverages"
        },
        {
            "id": 46,
            "name": "Avoid Sweets, Dessert, and Candy"
        },
        {
            "id": 56,
            "name": "Cook Dinner More Often"
        },
        {
            "id": 51,
            "name": "Drink 8 Glasses of Water a Day"
        },
        {
            "id": 49,
            "name": "Drink Less Booze"
        },
        {
            "id": 69,
            "name": "Eat 2 Servings of Whole Grains"
        },
        {
            "id": 40,
            "name": "Eat 3 Servings of Fruits & Veggies Per Day"
        },
        {
            "id": 53,
            "name": "Eat 5 Servings of Fruits & Veggies Per Day"
        },
        {
            "id": 54,
            "name": "Eat At Least 1 Distraction-Free Meal Per Day"
        },
        {
            "id": 62,
            "name": "Eat Less Dairy"
        },
        {
            "id": 66,
            "name": "Eat Less Fish"
        },
        {
            "id": 67,
            "name": "Eat Less Poultry"
        },
        {
            "id": 60,
            "name": "Eat Less Red Meat"
        },
        {
            "id": 61,
            "name": "Eat More Plant-based Proteins"
        },
        {
            "id": 48,
            "name": "Eat One Bite At A Time"
        },
        {
            "id": 57,
            "name": "Eat Real Food"
        },
        {
            "id": 76,
            "name": "Eat When You're Hungry"
        },
        {
            "id": 39,
            "name": "Fill 50% of your plate with Fruits and Veggies"
        },
        {
            "id": 72,
            "name": "Increase Dairy"
        },
        {
            "id": 74,
            "name": "Increase Fish"
        },
        {
            "id": 71,
            "name": "Increase Lean Poultry"
        },
        {
            "id": 50,
            "name": "Make Your Lunch More Often"
        },
        {
            "id": 42,
            "name": "No Food Waste"
        },
        {
            "id": 63,
            "name": "Remove Dairy"
        },
        {
            "id": 64,
            "name": "Remove Eggs"
        },
        {
            "id": 65,
            "name": "Remove Fish"
        },
        {
            "id": 70,
            "name": "Remove Red Meat"
        },
        {
            "id": 55,
            "name": "Stop Eating 2 Hours Before Bed"
        },
        {
            "id": 44,
            "name": "Avoid Added Sugar"
        },
        {
            "id": 45,
            "name": "Eat Less Animal Products"
        }
    ]
}`}
            />
          </Grid>
          <Grid
            item
            xs={2}
          >
            <h3>Error Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
    "success": "false",
    "message": "Must be logged in"
}
  `}
            />
          </Grid>
        </Grid>
      </Typography>
    </AccordionDetails>
  );
};
const Wrapper = () => {
  return (
    <React.Suspense fallback={<AdminProgressBar />}>
      <Challenges />
    </React.Suspense>
  );
};
export default Wrapper;
